import { useState } from "react"

// Wizard navigation state for the voyage planner. Lives inside the panel
// (not MainComponent); the panel resets it to the Plan step on every open.
export default function useWizardState() {
  const [wizardStep, setWizardStep] = useState(0)
  const [specTab, setSpecTab] = useState(0)

  return { wizardStep, specTab, setSpecTab, goToStep: setWizardStep }
}
